import { render } from "./GiveParticipation.vue?vue&type=template&id=2ef4c54f"
import script from "./GiveParticipation.vue?vue&type=script&lang=js"
export * from "./GiveParticipation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__